import { render, staticRenderFns } from "./EventsBannerDetail.vue?vue&type=template&id=70278deb&scoped=true"
import script from "./EventsBannerDetail.vue?vue&type=script&lang=js"
export * from "./EventsBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./EventsBannerDetail.vue?vue&type=style&index=0&id=70278deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70278deb",
  null
  
)

export default component.exports